import React, { FC } from 'react'
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    makeStyles,
    createStyles,
    IconButton,
    TableContainer
} from '@material-ui/core'

import { Edit as EditIcon } from '@material-ui/icons'
import { StoreDto } from './entities/StoreDto'
import { Pagination, PaginationProps } from '../../components/Pagination'

interface Props extends PaginationProps {
    data?: StoreDto[]

    onEdit?: (id: number) => void
}

export const StoreTable: FC<Props> = ({
    data = [],
    onEdit,
    pagination,
    onPaginationChange
}) => {
    const styles = useStyles()

    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell align='center'>Codigo</TableCell>
                        <TableCell align='center'>Nombre</TableCell>
                        <TableCell align='center'>Dirección</TableCell>
                        <TableCell align='center'>Estado</TableCell>
                        <TableCell align='center'>Acciones</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        data.map(item => {
                            return (
                                <TableRow key={item.storeId}>
                                    <TableCell align='center'>{item.code}</TableCell>
                                    <TableCell align='center'>{item.name}</TableCell>
                                    <TableCell align='center'>{item.streetName} {item.streetNumber}, {item.neighborhood}, {item.state}</TableCell>
                                    <TableCell align='center'>{item.active ? 'Activo' : 'Inactivo'}</TableCell>
                                    <TableCell align='center'>
                                        <div className={styles.action}>
                                            <IconButton onClick={() => onEdit && onEdit(item.storeId)}>
                                                <EditIcon />
                                            </IconButton>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            )
                        })
                    }
                </TableBody>
            </Table>
            <Pagination pagination={pagination} onPaginationChange={onPaginationChange}/>
        </TableContainer>
    )
}

const useStyles = makeStyles(
    createStyles({
        action: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-evenly',
        }
    })
)

